import {createClient} from '@sanity/client'

export const client = createClient({
  projectId: process.env.REACT_APP_PROJECT_ID,
  dataset: process.env.REACT_APP_DATA_SET,
  useCdn: true, // set to `true` to fetch from edge cache
  apiVersion: '2021-10-21', // use current date (YYYY-MM-DD) to target the latest API version
  // token: process.env.SANITY_SECRET_TOKEN // Only if you want to update content with the client
})

// uses GROQ to query content: https://www.sanity.io/docs/groq
export async function getUser() {
  const data = await client.fetch('*[_type == "user"]')
  return data
}

export async function getProjects() {
  const data = await client.fetch('*[_type == "projects"] | order(id)')
  return data
}

export async function getProjectDetails() {
  const data = await client.fetch('*[_type == "projects"] { details }')
  return data
}

export async function getProjectTitles() {
  const data = await client.fetch('*[_type == "projects"] | order(id) {  details { title } } ')
  const titles = data.map((project) => project.details.title).filter(Boolean);
  return titles;
}

export async function getPortfolioLogos() {
  const data = await client.fetch('*[_type == "assets"]')
  return data;
}

export async function getSkills() {
  const data = await client.fetch('*[_type == "skills"] | order(id)')
  return data;
}